// src/store/api/wishlist.js
import api from './base';

/**
 * Get user's wishlist
 * @returns {Promise} - API response
 */
export const getWishlist = async () => {
  const response = await api.get('/wishlist');
  return response.data;
};

/**
 * Add product to wishlist
 * @param {String} productId - Product ID
 * @returns {Promise} - API response
 */
export const addToWishlist = async (productId) => {
  const response = await api.post('/wishlist/add', { productId });
  return response.data;
};

/**
 * Remove product from wishlist
 * @param {String} productId - Product ID
 * @returns {Promise} - API response
 */
export const removeFromWishlist = async (productId) => {
  const response = await api.delete(`/wishlist/remove/${productId}`);
  return response.data;
};

/**
 * Clear entire wishlist
 * @returns {Promise} - API response
 */
export const clearWishlist = async () => {
  const response = await api.delete('/wishlist/clear');
  return response.data;
};

/**
 * Move product from wishlist to cart
 * @param {String} productId - Product ID
 * @returns {Promise} - API response
 */
export const moveToCart = async (productId) => {
  const response = await api.post(`/wishlist/${productId}/move-to-cart`);
  return response.data;
};

/**
 * Check if product is in wishlist
 * @param {String} productId - Product ID
 * @returns {Promise} - API response
 */
export const checkWishlistItem = async (productId) => {
  const response = await api.get(`/wishlist/check/${productId}`);
  return response.data;
};